<template>
  <div>
    <my-header></my-header>
    <div class="content-box team-banner">
      <div class="content-detail">
        <p class="title">核心团队</p>
        <p class="text">汇集全国40+专业基地</p>
        <p class="text">齐聚各领域业界人气大神、主委级专家等</p>
        <button class="btn">查看详情</button>
      </div>
    </div>
    <div class="content-box team-content">
      <div class="content-detail">
        <ul class="tabs">
          <li class="li" :class="{'active': tabIndex === item.id}" v-for="(item, index) in tabList" :key="index" @click="tabClick(item, index)">{{item.name}}</li>
        </ul>
        <div class="show" v-if="topHospital">
          <el-carousel :interval="5000" arrow="never" class="team-img-box" v-if="topHospital.pictureList.length">
            <el-carousel-item v-for="(item, index1) in topHospital.pictureList" :key="index1">
              <img :src="`${item.imgUrl}`" @click="toPage(topHospital)"/>
            </el-carousel-item>
          </el-carousel>
          <div class="show-box" @click="toPage(topHospital)">
            <p class="hospital">{{topHospital.name}}</p>
            <div class="tag-box">
              <span class="tag year">{{topHospital.establishTime}}</span>
              <span v-if="levelArr[topHospital.level]" class="tag level" :class="levelArr[topHospital.level].cls">{{levelArr[topHospital.level].name}}</span>
              <span v-if="topHospital.honoraryTitle" class="tag level">{{topHospital.honoraryTitle}}</span>
            </div>
            <!-- <p class="info">教学团队：</p> -->
            <ul class="doctor" v-if="topHospital.memberList">
              <li class="doctor-li" v-for="(item1, index1) in topHospital.memberList" :key="index1">
                <div :class="{'img-border':jobArr[item1.jobTitle].cls=='one'}">
                  <img class="head" :src="`/${item1.imgUrl}`"/>
                </div>
                <span v-if="jobArr[item1.jobTitle]" class="position" :class="jobArr[item1.jobTitle].cls">
                  <!-- <img v-if="!item1.jobTitle" class="img" src="/static/img/team/01.png"/> -->
                  {{item1.name}}</span>
                <p class="name">{{jobArr[item1.jobTitle].name}}</p>
              </li>
            </ul>
          </div>
        </div>
        <ul class="team-list">
          <li class="li" :class="{'margin24': (index + 1) % 3 !== 0}" v-for="(item, index) in teamList" :key="index"  @click="toPage(item)">
            <div class="bg"></div>
            <img class="img" v-if="item.pictureList[0]" :src="`${item.pictureList[0].imgUrl}`"/>
            <p class="title"><span class="hospital-name">{{item.name}}</span><span class="level" v-if="levelArr[item.level]">{{levelArr[item.level].name}}</span></p>
            <!-- <p class="info">教学团队：</p> -->
            <ul class="doctor" v-if="item.memberList">
              <li class="doctor-li" v-for="(item1, index1) in item.memberList" :key="index1">
                <div  :class="{'img-border':jobArr[item1.jobTitle].cls=='one'}">
                  <img class="head" :src="`${item1.imgUrl}`"/>
                </div>
                <span v-if="jobArr[item1.jobTitle]" class="position" :class="jobArr[item1.jobTitle].cls">{{item1.name}}</span>
                <p class="name">{{jobArr[item1.jobTitle].name}}</p>
              </li>
            </ul>
          </li>
        </ul>
        <div class="more" v-show="teamList.length < allTeamList.length">
          <button @click="getMore">了解更多<i class="el-icon-arrow-right i1"></i><i class="el-icon-arrow-right i2"></i><i class="el-icon-arrow-right i3"></i></button>
        </div>
      </div>
      <div class="empty" v-show="!allTeamList.length">
        <img src="/static/img/empty.png">
        <p>没有更多了~</p>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import { officialSiteServer } from '@/api/api'
import getImgUrl from '@/mixin/getImgUrl.js'
import myFooter from './myFooter.vue'
import myHeader from './myHeader.vue'
export default {
  name: 'team',
  components: {
    myHeader: myHeader,
    myFooter: myFooter
  },
  mixins: [getImgUrl],
  data () {
    return {
      tabList: [
        { name: '放射诊断学', id: '0' },
        { name: '放射技术学', id: '2' },
        { name: '超声影像学', id: '1' },
        { name: '核医学', id: '5' },
        { name: '心电学', id: '3' },
        { name: '病理学', id: '4' },
        { name: '内镜学', id: '6' }
      ],
      levelArr: [
        { name: '', cls: '' },
        { name: '三级甲等', cls: '' },
        { name: '三级乙等', cls: '' },
        { name: '三级丙等', cls: '' },
        { name: '三级特等', cls: '' },
        { name: '二级甲等', cls: '' },
        { name: '二级乙等', cls: '' },
        { name: '二级丙等', cls: '' },
        { name: '一级甲等', cls: '' },
        { name: '一级乙等', cls: '' },
        { name: '一级丙等', cls: '' }
      ],
      tabIndex: '0',
      teamList: [],
      allTeamList: [],
      teamIndex: 0,
      topHospital: null,
      jobArr: [
        { name: '基地主任', cls: 'one' },
        { name: '教学主任', cls: 'color' },
        { name: '教学秘书', cls: 'color' }
      ]
    }
  },
  beforeDestroy () {
  },
  mounted () {
    this.readTeam()
  },
  methods: {
    tabClick (item) {
      if (this.tabIndex === item.id) return
      this.tabIndex = item.id
      this.readTeam()
    },
    readTeam () {
      this.topHospital = null
      this.teamList = []
      this.allTeamList = []
      officialSiteServer.queryTeamList({
        orgType: this.tabIndex
      }).then((res) => {
        let { code, data } = res
        if (code === '0') {
          data.forEach((item, index) => {
            item.picture = item.picture ? item.picture.split(',') : []
            item.pictureList = []
            item.picture.forEach(e => {
              item.pictureList.push({
                img: e
              })
            })
            // this.getImgUrl(item.pictureList, 'img')
            item.img = item.img ? item.img.split(',') : []
            item.imgList = []
            item.img.forEach(e => {
              item.imgList.push({
                img: e
              })
            })
          })
          this.getMoreImgUrl(data, [
            { name: 'pictureList', attr: 'img' },
            { name: 'imgList', attr: 'img' },
            { name: 'memberList', attr: 'showImg' }
          ]).then(() => {
            if (data[0] && data[0].leading) this.topHospital = data.shift()
            this.allTeamList = data
            this.teamList = data.slice(0, 6)
            this.teamIndex = 6
          })
        }
      })
    },
    toPage (item) {
      localStorage.setItem('hospital', JSON.stringify(item))
      // document.documentElement.scrollTop = document.body.scrollTop = 0
      // this.$router.push({ path: '/detail' })
      let rourteUrl = this.$router.resolve({
        path: '/detail'
      })
      window.open(rourteUrl.href, '_blank')
    },
    getMore () {
      if (this.allTeamList.length > this.teamList.length) {
        this.teamIndex += 6
        if (this.allTeamList.length > this.teamIndex) {
          this.teamList = this.allTeamList.slice(0, this.teamIndex)
        } else {
          this.teamList = this.allTeamList
        }
      }
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
@import "~less-lib";
@media (min-width: 1920px) {
  .team-banner{
    background: url("/static/img/team/banner.png") no-repeat;
  }
}
@media (max-width: 1920px) {
  .team-banner{
    background: url("/static/img/team/banner1.jpg") no-repeat;
  }
}
.team-banner {
  height: 560px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .content-detail {
    height: 560px;
    padding-top: 102px;
    text-align: left;
  }
  .title {
    font-family: AlibabaPuHuiTi-Medium;
    font-size: 80px;
    line-height: 110px;
    color: #FFFFFF;
    letter-spacing: 7.11px;
    margin-bottom: 26px;
  }
  .text {
    font-family: AlibabaPuHuiTi-Regular;
    font-size: 30px;
    line-height: 42px;
    color: #FFFFFF;
    letter-spacing: 2.67px;
    font-weight: 400;
  }
  .btn {
    width: 126px;
    height: 46px;
    line-height: 46px;
    background: #0C59EF;
    border-radius: 4px;
    font-family: SourceHanSansSC-Medium;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 1.42px;
    position: absolute;
    left: 0;
    bottom: 120px;
    cursor: pointer;
  }
}
.team-content {
  .tabs {
    height: 64px;
    text-align: left;
    margin-bottom: 100px;
    .li {
      display: inline-block;
      height: 64px;
      line-height: 64px;
      font-family: SourceHanSansSC-Medium;
      font-size: 14px;
      color: #000000;
      border-bottom: 1px solid #fff;
      margin-right: 50px;
      cursor: pointer;
    }
    .active {
      color: #0C59EF;
      border-bottom: 1px solid #0C59EF;
    }
  }
  .show {
    width: 1200px;
    height: 447px;
    position: relative;
    background: #FFFFFF;
    box-shadow: 0 0 20px 0 rgba(0,0,0,0.10);
    border-radius: 14px;
    padding: 77px 0 0 620px;
    margin-bottom: 80px;
    cursor: pointer;
    overflow: hidden;
    .team-img-box {
      width: 596px;
      height: 447px;
      position: absolute;
      left: 0;
      top: 0;
      img {
        width: 596px;
        height: 447px;
      }
    }
    .show-box {
      width: 604px;
      height: 447px;
      position: absolute;
      right: 0;
      top: 0;
      padding-top: 77px;
      padding-left: 24px;
      background: url("/static/img/team/center-back.png") no-repeat;
      background-size: 100% 100%;
    }
    .hospital {
      font-family: SourceHanSansSC-Medium;
      font-size: 24px;
      color: #000000;
      text-align: left;
      line-height: 33px;
      margin-bottom: 24px;
      position: absolute;
      top: 20px;
      width: 580px;
    }
    .info {
      font-family: SourceHanSansSC-Medium;
      font-size: 14px;
      color: #000000;
      text-align: left;
      line-height: 20px;
      padding-left: 12px;
      margin-bottom: 20px;
    }
    .doctor {
      text-align: left;
    }
    .doctor-li {
      // width: 140px;
      width: 152px;
      // height: 152px;
      // border-radius: 50%;
      margin-right: 25px;
      display: inline-block;
      text-align: center;
      .img-border{
        width: 152px;
        height: 152px;
        border: 2px solid transparent;
        box-sizing: border-box;
        border-radius: 50%;
        background-clip: padding-box, border-box;
        background-origin: padding-box, border-box;
        background-image: linear-gradient(to right, #fff, #fff),
        linear-gradient( #3FB5FF, #A8F9FF);
        position: relative;
        img{
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
        }
      }
    }
    .doctor-li:last-child {
      margin: 0;
    }
    .head {
      width: 140px;
      height: 140px;
      border-radius: 50%;
    }
    .position {
      width: 123px;
      height: 38px;
      line-height: 38px;
      font-family: SourceHanSansSC-Medium;
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      font-weight: 500;
      // background: #4066F1;
      border-radius: 19px;
      display: inline-block;
      margin: 10px 0;
      position: relative;
    }
    .one {
      // padding-left: 30px;
    }
    .img {
      width: 38px;
      height: 38px;
      position: absolute;
      left: -1px;
    }
    .color {
      // background: #957CFF;
    }
    .name {
      font-family: SourceHanSansSC-Regular;
      font-size: 14px;
      color: #666666;
      font-weight: 400;
    }
    .tag-box {
      text-align: left;
      margin-bottom: 78px;
    }
    .tag {
      padding: 5px 20px;
      display: inline-block;
      text-align: center;
      border-radius: 4px;
      font-family: SourceHanSansSC-Regular;
      margin-right: 24px;
      font-size: 14px;
    }
    .year {
      background: #FFF6EC;
      color: #E7871E;
    }
    .level {
      background: #EAF7FF;
      color: #0C59EF;
    }
  }
  .team-list {
    text-align: left;
    .li {
      width: 384px;
      height: 493px;
      border-radius: 14px;
      overflow: hidden;
      box-shadow: 0 0 20px 0 rgba(0,0,0,0.10);
      margin-bottom: 40px;
      display: inline-block;
      position: relative;
      text-align: center;
      cursor: pointer;
      padding-top: 301px;
    }
    .bg {
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,0.06);
      display: none;
      z-index: 2;
      left: 0;
      top: 0;
    }
    .li:hover {
      .bg {
        display: inline-block;
      }
    }
    .margin24 {
      margin-right: 24px;
    }
    .img {
      width: 384px;
      height: 216px;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
    }
    .title {
      font-family: SourceHanSansSC-Medium;
      font-size: 24px;
      line-height: 33px;
      color: #000000;
      position: absolute;
      top: 236px;
      left: 0;
      padding-left: 20px;
      text-align: left;
    }
    .hospital-name {
      margin-right: 24px;
      font-family: SourceHanSansSC-Medium;
    }
    .level {
      padding: 5px 12px;
      display: inline-block;
      vertical-align: top;
      text-align: center;
      background: #EAF7FF;
      border-radius: 4px;
      font-family: SourceHanSansSC-Regular;
      font-size: 14px;
      line-height: 20px;
      color: #0C59EF;
    }
    .info {
      font-family: SourceHanSansSC-Medium;
      font-size: 14px;
      color: #000000;
      text-align: left;
      line-height: 20px;
      padding-left: 20px;
      margin-bottom: 20px;
    }
    .doctor {
      text-align: left;
      padding-left: 20px;
    }
    .doctor-li {
      width: 90px;
      margin-right: 37px;
      display: inline-block;
      text-align: center;
      .img-border{
        width: 102px;
        height: 102px;
        border: 2px solid transparent;
        box-sizing: border-box;
        border-radius: 50%;
        background-clip: padding-box, border-box;
        background-origin: padding-box, border-box;
        background-image: linear-gradient(to right, #fff, #fff),
        linear-gradient( #3FB5FF, #A8F9FF);
        position: relative;
        img{
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
        }
      }
    }
    .doctor-li:last-child {
      margin: 0;
    }
    .head {
      width: 90px;
      height: 90px;
      border-radius: 50%;
    }
    .position {
      width: 84px;
      height: 30px;
      line-height: 30px;
      font-family: SourceHanSansSC-Medium;
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      // background: #4066F1;
      border-radius: 15px;
      display: inline-block;
      margin: 10px 0;
    }
    .color {
      // background: #957CFF;
    }
    .name {
      font-family: SourceHanSansSC-Regular;
      font-size: 14px;
      color: #666;
      font-weight: 400;
    }
  }
  .more {
    padding: 96px 0 120px 0;
    button {
      height: 25px;
      line-height: 25px;
      font-family: SourceHanSansSC-Medium;
      font-size: 18px;
      color: #666666;
      background: none;
      cursor: pointer;
      position: relative;
      width: 105px;
      text-align: left;
    }
    i {
      color: #979797;
      position: absolute;
      top: 3px;
    }
    .i1 {
      right: 14px;
    }
    .i2 {
      opacity: .6;
      right: 7px;
    }
    .i3 {
      opacity: .4;
      right: 0;
    }
    button:hover {
      color: #0C59EF;
      i {
        color: #0C59EF;
      }
    }
  }
}
</style>
<style lang="less">
.team-img-box {
  .el-carousel__container {
    height: 447px;
  }
  .el-carousel__button {
    width: 8px;
    height: 8px;
    background: #BDBDBD;
    border-radius: 8px;
    opacity: 1;
  }
  .is-active {
    .el-carousel__button {
      width: 20px;
      background: #0056F8;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/team.vue